import superagent from 'superagent';
import cookie from 'react-cookie';
import config from '~/config';
import AuthService from './AuthService';
import ErrorService from './ErrorService';
import { xsrfCookieName } from '~/constants/ModelConstants';

const methods = ['get', 'post', 'put', 'patch', 'del'];

function formatUrl(path, shouldUseVeracodeApi) {
  if (path.startsWith('http')) {
    return path;
  }
  const adjustedPath = path[0] !== '/' ? '/' + path : path;
  const url = shouldUseVeracodeApi ? config.VC_API_URL : config.API_URL;
  return url + adjustedPath;
}

class ApiService {
  constructor() {
    methods.forEach(
      method =>
        (this[method] = (path, { params, data, headers, shouldUseVeracodeApi } = {}) =>
          new Promise((resolve, reject) => {
            const request = superagent[method](formatUrl(path, shouldUseVeracodeApi));
            const token = AuthService.getAuthToken();
            headers = {
              ...headers,
              Accept: 'application/json',
              ...(shouldUseVeracodeApi && { 'X-XSRF-TOKEN': cookie.load(xsrfCookieName) }),
            };

            headers['x-auth-token'] = token;
            request.type('application/json');
            request.withCredentials();

            if (params) {
              request.query(params);
            }

            if (data) {
              request.send(data);
            }

            if (headers) {
              request.set(headers);
            }

            request.end((err, res = {}) => {
              const { body } = res;
              if (err) {
                if (err.status !== 401) {
                  ErrorService.capture(err, { err, params, data });
                }
                reject(body || err);
              } else {
                resolve(body);
              }
            });
          }))
    );
  }
  empty() {}
}

export default new ApiService();
